import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import './TermsConditionsSection.css';

const termsConditionsData = [
  {
    title: 'Terms & Conditions',
    content: [
      'Welcome to RSKPay! These terms and conditions outline the rules and regulations for the use of RSKPay\'s Website and Mobile Application, located at RSKPay.com and RSKPay mobile app.',
      'By accessing this website and mobile application, we assume you accept these terms and conditions. Do not continue to use RSKPay if you do not agree to take all of the terms and conditions stated on this page.',
      'The following terminology applies to these Terms and Conditions: "Company" (or "us" or "we" or "RSKPay") refers to RSK Online Services PVT.LTD., which owns RSKPay. "You" refers to the person accessing and using RSKPay.',
      'RSKPay is developed and owned by RSK Online Services PVT.LTD., a company incorporated under the Companies Act, 1956 with its registered office at 649 Harikrupa Appartment, Old Bagadganj, Nagpur - 440008, India.',
      'By using our service, you agree to be bound by these Terms and Conditions and our Privacy Policy. If you disagree with any part of these terms, then you may not access the service.',
      'We reserve the right to modify these terms at any time. We will notify users of any changes by posting the new Terms and Conditions on this page.'
    ]
  },
  {
    title: 'Use License',
    content: [
      'Permission is granted to temporarily download one copy of RSKPay mobile application per device for personal, non-commercial transitory viewing only.',
      'This is the grant of a license, not a transfer of title, and under this license you may not:',
      '• Modify or copy the materials',
      '• Use the materials for any commercial purpose or for any public display (commercial or non-commercial)',
      '• Attempt to decompile or reverse engineer any software contained in RSKPay',
      '• Remove any copyright or other proprietary notations from the materials',
      'This license shall automatically terminate if you violate any of these restrictions and may be terminated by RSKPay at any time.',
      'Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.'
    ]
  },
  {
    title: 'User Account',
    content: [
      'To access certain features of RSKPay, you must create an account and provide accurate, complete, and current information.',
      'You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.',
      'You agree to immediately notify RSKPay of any unauthorized use of your account or any other breach of security.',
      'RSKPay will not be liable for any loss or damage arising from your failure to comply with this section.',
      'You may not use another person\'s account without permission.',
      'Account creation is subject to our verification process and we reserve the right to refuse service to anyone.'
    ]
  },
  {
    title: 'Services and Transactions',
    content: [
      'RSKPay provides a platform for mobile recharge, bill payments, money transfers, and other financial services.',
      'All transactions are subject to the terms and conditions of respective service providers and banks.',
      'RSKPay acts as an intermediary and is not responsible for the quality or delivery of services by third-party providers.',
      'Transaction charges, processing fees, and other applicable charges will be clearly displayed before confirmation.',
      'All transactions are final once processed. Refunds are subject to our Refund Policy.',
      'You agree to provide accurate information for all transactions.',
      'RSKPay reserves the right to refuse, cancel, or hold any transaction at its discretion.'
    ]
  },
  {
    title: 'Payment Terms',
    content: [
      'Payment for services must be made through the accepted payment methods displayed in the app.',
      'All payments are processed through secure payment gateways.',
      'You authorize RSKPay to charge your selected payment method for all transactions.',
      'In case of payment failures, you may be required to complete the payment through alternative methods.',
      'Any charges or fees imposed by your bank or payment provider are your responsibility.',
      'Failed transactions will be refunded according to our Refund Policy.',
      'All prices are inclusive of applicable taxes unless otherwise stated.'
    ]
  },
  {
    title: 'User Conduct',
    content: [
      'You agree to use RSKPay only for lawful purposes and in accordance with these Terms.',
      'You agree not to use RSKPay:',
      '• For any unlawful purpose or to solicit others to unlawful acts',
      '• To violate any international, federal, provincial, or state regulations, rules, laws, or local ordinances',
      '• To transmit, or procure the sending of, any advertising or promotional material, including any "junk mail," "chain letter," "spam," or any other similar solicitation',
      '• To impersonate or attempt to impersonate the Company, a Company employee, another user, or any other person or entity',
      '• To engage in any other conduct that restricts or inhibits anyone\'s use or enjoyment of RSKPay',
      'We reserve the right to terminate your account for violations of these terms.'
    ]
  },
  {
    title: 'Privacy Policy',
    content: [
      'Your privacy is important to us. Our Privacy Policy explains how we collect, use, and protect your information when you use RSKPay.',
      'By using our service, you agree to the collection and use of information in accordance with our Privacy Policy.',
      'We implement appropriate security measures to protect your personal information.',
      'We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in our Privacy Policy.',
      'You can access and update your personal information through your account settings.',
      'For any privacy-related concerns, please contact us at admin@rskonlineservices.com'
    ]
  },
  {
    title: 'Disclaimer',
    content: [
      'The information on RSKPay is provided on an "as is" basis.',
      'To the fullest extent permitted by law, RSKPay excludes all representations, warranties, conditions, and terms.',
      'RSKPay shall not be liable for any damages arising from the use or inability to use the service.',
      'We do not warrant that the service will be uninterrupted, timely, secure, or error-free.',
      'We do not warrant the accuracy or completeness of the information available through the service.',
      'Your use of any information or materials on RSKPay is entirely at your own risk.',
      'It shall be your own responsibility to ensure that any products, services, or information available through RSKPay meet your specific requirements.'
    ]
  },
  {
    title: 'Limitation of Liability',
    content: [
      'In no event shall RSKPay or its suppliers be liable for any damages arising out of the use or inability to use RSKPay.',
      'This includes, without limitation, damages for loss of profits, loss of data, or business interruption.',
      'Our total liability to you for all damages shall not exceed the amount paid by you to RSKPay in the 12 months preceding the claim.',
      'Some jurisdictions do not allow the exclusion of certain warranties or the limitation of liability, so these limitations may not apply to you.',
      'RSKPay shall not be liable for any indirect, incidental, special, consequential, or punitive damages.',
      'You agree that any legal action arising out of or related to these Terms must be commenced within one year after the claim arose.'
    ]
  },
  {
    title: 'Termination',
    content: [
      'We may terminate or suspend your account and bar access to RSKPay immediately, without prior notice, for any reason.',
      'Upon termination, your right to use RSKPay will cease immediately.',
      'If you wish to terminate your account, you may discontinue using RSKPay.',
      'All provisions of the Terms which should survive termination shall survive termination.',
      'Termination will not limit any of our rights or remedies at law or in equity.',
      'We reserve the right to refuse service to anyone for any reason at any time.'
    ]
  },
  {
    title: 'Governing Law',
    content: [
      'These Terms shall be interpreted and governed by the laws of India.',
      'Any disputes arising out of or related to these Terms shall be subject to the exclusive jurisdiction of the courts in Nagpur, Maharashtra.',
      'If any provision of these Terms is held to be invalid or unenforceable, the remaining provisions will remain in full force and effect.',
      'Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights.',
      'These Terms constitute the entire agreement between us regarding our service.'
    ]
  },
  {
    title: 'Contact Information',
    content: [
      'If you have any questions about these Terms and Conditions, please contact us:',
      '',
      'Email: admin@rskonlineservices.com',
      '',
      'Address:',
      'RSK Online Services PVT.LTD.',
      '649 Harikrupa Appartment, Old Bagadganj',
      'Nagpur - 440008, Maharashtra, India',
      '',
      'Last updated: October 1, 2025'
    ]
  }
];

function TermsConditionsSection() {
  const [activeSection, setActiveSection] = useState(0);

  return (
    <section id="terms-conditions" className="terms-conditions">
      <div className="terms-container">
        <h1>
          <span>Terms &</span>
          <span className="text-gradient"> Conditions</span>
        </h1>
        
        <div className="terms-content">
          <div className="terms-accordion">
            {termsConditionsData.map((section, index) => (
              <div key={index} className="terms-item">
                <button
                  className={`terms-header ${activeSection === index ? 'active' : ''}`}
                  onClick={() => setActiveSection(activeSection === index ? -1 : index)}
                >
                  {section.title}
                  <span className={`terms-toggle ${activeSection === index ? 'active' : ''}`}>
                    <FaChevronDown />
                  </span>
                </button>
                
                {activeSection === index && (
                  <div className="terms-body">
                    {section.content.map((paragraph, pIndex) => (
                      <p key={pIndex} className="terms-paragraph">
                        {paragraph}
                      </p>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default TermsConditionsSection;